<div class="bc-row">
    <div class="bc-col-12">
        <div class="bc-col-6">
            <div class="divBreadCrumb">
                <bc-breadcrumb></bc-breadcrumb>
            </div>            
            <p *ngIf="this.routerInterno.url == this.routerPath" class="breadcrumbMocket">Inicio</p>
        </div>
        <div class="bc-col-6 justificar-texto-derecha ultimo-ingreso">
            <span>Tu último ingreso fue el {{ ultima_conexion }}</span>
        </div>        
    </div>
</div>
<div class="bc-row">
    <div class="bc-col-lg-12">
        <h1 class="titulo">{{titulo}}</h1>
    </div>
</div>